import { render, staticRenderFns } from "./RegisterCompleted.vue?vue&type=template&id=3d893140"
import script from "./RegisterCompleted.vue?vue&type=script&lang=js"
export * from "./RegisterCompleted.vue?vue&type=script&lang=js"
import style0 from "./RegisterCompleted.vue?vue&type=style&index=0&id=3d893140&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports